/**
 *
 * @author: Huning
 * @date: 2019-07-05
 *
 */
import React, { PureComponent, Fragment } from 'react'
import PropTypes from 'prop-types'
import { CSSTransition } from 'react-transition-group'

import style from './index.less'

class FilterContent extends PureComponent {
  static propTypes = {
    open: PropTypes.bool
  }

  static defaultProps = {
    open: false
  }

  onClick = e => {
    const { nativeEvent } = e
    if (window.event) {
      window.event.cancelBubble = true
    } else {
      nativeEvent.stopPropagation()
    }
  }

  render() {
    const { props } = this
    const { children, open } = props

    return (
      <div onClick={this.onClick} className={`${style.content}`}>
        <CSSTransition in={open} classNames="move-up" timeout={200}>
          <div className={`${style.container} ${open ? style.container_show : ''}`}>{children}</div>
        </CSSTransition>
      </div>
    )
  }
}

export default FilterContent
